function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import changeReducerFactory from './factories/changeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import reportTagConstants from '../constants/reportTagConstants';
import applyReducer from './applyReducer';
import { findNode, findParent } from '../components/admin/tags/reportTagHelpers';
const entityReducer = entityReducerFactory('reportTag');
const changeReducer = changeReducerFactory('reportTag');
const detailReducer = detailReducerFactory('reportTag');
const indexQuery = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), changeReducer.initState.indexQuery), detailReducer.initState.indexQuery), {}, {
  paging: null
});
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityReducer.initState), changeReducer.initState), detailReducer.initState), {}, {
  indexQuery,
  initialIndexQuery: indexQuery,
  permissions: {
    view: {
      include: ['job_edit']
    },
    edit: {
      include: ['reportTag_edit']
    }
  }
});
/**
 * Ensures that the node is successfuly merged into the
 * report tag structure without mutating the original
 * structure.
 * @param {Object} state - reportTag state object
 * @param {Object} action - serverSaveSuccess action
 * @param {Object} action.data - node information
 */
const serverSaveSuccess = (state, action) => {
  const root = {
    nodes: JSON.parse(JSON.stringify(state.list)),
    id: null
  };
  const parentNode = findNode(action.data.parentID, root);
  const existingIndex = parentNode.nodes.findIndex(node => node.id === action.data.id);
  if (existingIndex !== -1) {
    parentNode.nodes[existingIndex] = action.data;
  } else {
    parentNode.nodes.push(_objectSpread(_objectSpread({}, action.data), {}, {
      isNew: false
    }));
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    list: root.nodes
  });
};

/**
 * Removes any retruned ids from the report tag structure
 * without directly mutating the original structure.
 * @param {Object} state - reportTag state object
 * @param {Object} action - serverDestroySuccess action
 * @param {Array} action.ids - list of destroyed nodes
 */
const serverDestroySuccess = (state, action) => {
  const root = {
    nodes: JSON.parse(JSON.stringify(state.list)),
    id: null
  };
  const [id] = action.ids;
  const parent = findParent(id, root);
  const index = parent.nodes.findIndex(node => node.id === id);
  parent.nodes.splice(index, 1);
  return _objectSpread(_objectSpread({}, state), {}, {
    list: root.nodes
  });
};
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), {}, {
  [reportTagConstants.SAVE_SUCCESS]: serverSaveSuccess,
  [reportTagConstants.DESTROY_SUCCESS]: serverDestroySuccess
});
export default applyReducer(reducers, initState);